import React, { useEffect, useState } from "react";
import { List, Button, Card, Row, Col, message, Space, Tooltip } from "antd";
import { AppstoreOutlined, BarsOutlined, HeartOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import MarketPlaceService from "../../../utils/api/marketplace";


const ProductList = ({ catalog, category }) => {
  let role = localStorage.getItem("role");
  let history = useNavigate();
  const [loadProducts, setLoadProducts] = useState(true);
  const [products, setProducts] = useState([]);
  const [isGalleryView, setIsGalleryView] = useState(true);

  useEffect(() => {
    setLoadProducts(true);
    MarketPlaceService.getProductsByCategory(category, catalog).then((resp) => {
      setProducts(resp.data.products);
      setLoadProducts(false);
    }).catch(() => {
      message.error("Error al cargar productos");
      setLoadProducts(false);
    });
  }, [category, catalog]);

  const handleCardClick = (product) => {
    history(product.link);
  };

  const handleAddToCart = (product) => {
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
        <div style={{ flex: 3 }}>
          <div style={{ marginBottom: 16, textAlign: "right" }}>
            <Space>
              <Tooltip title="Vista de galería">
                <Button
                  icon={<AppstoreOutlined />}
                  type={isGalleryView ? "primary" : "default"}
                  onClick={() => setIsGalleryView(true)}
                />
              </Tooltip>
              <Tooltip title="Vista de lista">
                <Button
                  icon={<BarsOutlined />}
                  type={!isGalleryView ? "primary" : "default"}
                  onClick={() => setIsGalleryView(false)}
                />
              </Tooltip>
            </Space>
          </div>

          <List
            grid={isGalleryView ? { gutter: 12, xs: 1, sm: 2, md: 3 } : undefined}
            dataSource={role === "4" ? products.filter(p => !p.archive) : products}
            loading={loadProducts}
            renderItem={(item) => {
              const price = Number(item.newPrice ?? item.price) || 0;
              return (
                <List.Item style={{ width: "100%" }}>
                  <Card
                    bordered={false}
                    style={{
                      borderRadius: 12,
                      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                      padding: 10,
                      position: "relative",
                      width: '100%',
                      opacity: item.archive ? 0.4 : 1,
                      pointerEvents: item.archive ? 'none' : 'auto',
                    }}
                    hoverable
                    onClick={() => handleCardClick(item)}
                  >
                    {isGalleryView ? (
                      <>
                        <div style={{ position: "absolute", top: 8, left: 8 }}>
                          <HeartOutlined style={{ color: "#00C897", fontSize: 20 }} />
                        </div>
                        <Col xs={24} style={{ textAlign: "center", marginTop: 20 }}>
                          <img
                            src={item.images[0]}
                            alt={item.name}
                            style={{ width: "100%", maxWidth: 160 }}
                          />
                        </Col>
                        <div style={{ textAlign: "left", marginTop: 10 }}>
                          <h3 style={{ marginBottom: 4 }}>{item.name}</h3>
                          <p style={{ color: "#00C897", margin: 0, fontWeight: "bold" }}>
                            {item.sub_category}
                          </p>
                          <p style={{ color: "#3B80FF", margin: "4px 0" }}>Sin costo de envío</p>
                        </div>
                        <Row justify="space-between" align="middle" style={{ marginTop: 8 }}>
                          <h2 style={{ marginRight: 10, marginBottom: 0 }}>
                            ${price.toFixed(2)} MXN+IVA
                          </h2>
                          <Button
                            icon={<ShoppingCartOutlined />}
                            style={{ background: 'linear-gradient(135deg, #1890ff, #096dd9)', color: "#fff", border: "none", borderRadius: 8, boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddToCart(item);
                            }}
                          />
                        </Row>
                      </>
                    ) : (
                      <Row gutter={16} align="middle">
                        <Col xs={4}>
                          <img
                            src={item.images[0]}
                            alt={item.name}
                            style={{ width: "100%", maxWidth: 100, borderRadius: 8 }}
                          />
                        </Col>
                        <Col xs={18}>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ flex: 3, marginRight: '10vh' }}>
                              <h3 style={{ marginBottom: 4 }}>{item.name}</h3>
                              <p style={{ color: "#00C897", margin: 0, fontWeight: "bold" }}>
                                {item.sub_category}
                              </p>
                              <p>
                                {item?.description?.slice(0, 150)}
                                {item?.description?.length > 150 ? '...' : ''}
                              </p>
                            </div>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                              <h2 style={{ margin: 0 }}>${price.toFixed(2)} MXN+IVA</h2>
                              <p style={{ color: "#3B80FF", margin: "4px 0" }}>Sin costo de envío</p>
                              <Button
                                icon={<ShoppingCartOutlined />}
                                style={{ background: 'linear-gradient(135deg, #1890ff, #096dd9)', color: "#fff", border: "none", borderRadius: 8, boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddToCart(item);
                                }}
                              >
                                Agregar al carrito
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Card>
                </List.Item>
              )
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ProductList;
